import NP, {EventArgs} from "../../NP";
import Control from "../../Control";
import IconToggleButton from "../IconToggleButton/IconToggleButton";
import Delegate from "../../Delegate";
import {ISelectItem} from "../Select/Select";

export interface IItem extends ISelectItem {
	FontImage?: string;
	Image?: string;
	Class?: string;
	Selectable?: boolean;
	AddToolTips?: boolean;
	ToolTip?: string;
	IsRadioButton?: boolean;
	IsHeader?: boolean;
	IsCheckBox?: boolean;
	DelBtnSettings?: any;
	EvDeletedClick?: Delegate;
	EvClick?: Delegate | Function;
	IsVisible?: boolean;
	SecondLine?: string;
	Enabled?: boolean;
	ShowDeleteButton?: boolean;
	Selected?: boolean;
	Tag?: any;
	SecondLineImages?: string[];
}

export default class ListItem extends Control {

	public EvDeletedClick: Delegate;
	public _IsSeparator: boolean;

	protected _FontImage: string;
	protected _Selected: boolean;
	protected _ShowDeleteButton: boolean;
	protected _Selectable: boolean;

	private _Image: string;
	private _SecondLine: string;
	private _SecondLineImages: Array<string>;

	private _DelBtnSettings: object;

	protected _AddToolTips: boolean;


	private _delButton: IconToggleButton;
	protected _deletedClick: boolean;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._FontImage = null;
		this._Image = null;
		this._SecondLine = null;
		this._SecondLineImages = null;
		this._IsSeparator = false;
		this._Selectable = true;
		this._DelBtnSettings = null;
		this._ShowDeleteButton = false;
		this._AddToolTips = false;
		this.EvDeletedClick = new Delegate();
		this._Selected = false;
		super._initFields(settings);
	}

	getSecondLine()
	{
		return this._SecondLine;
	}

	getSelectable()
	{
		return this._Selectable;
	}

	setSelectable(value: boolean)
	{
		this._Selectable = !!value;
	}

	_render()
	{
		if (this._IsSeparator)
		{
			this.np_render('<li role="separator" class="app-list-divider"></li>');
		}
		else
		{
			this.np_render(`<li class="app-list-item"></li>`);
			this.setContent(this._Content || NP.RM.getString(this._RK) || '');
		}
	}

	getSelected()
	{
		return this._Selected;
	}

	setSelected(value: boolean)
	{
		this._Selected = value;
		let node = this._root.querySelector('.app-list-item__meta');
		if (node && !node.matches('.app-list-item__delete'))
		{
			if (value)
			{
				NP.addCssClass(node, NP.FontImages.radiobutton_checked);
				NP.removeCssClass(node, NP.FontImages.radiobutton_unchecked);
			}
			else
			{
				NP.addCssClass(node, NP.FontImages.radiobutton_unchecked);
				NP.removeCssClass(node, NP.FontImages.radiobutton_checked);
			}
		}
		else
		{
			if (value)
			{
				NP.addCssClass(this._root, 'app-list-item--selected');
			}
			else
			{
				NP.removeCssClass(this._root, 'app-list-item--selected');
			}
		}
	}

	setContent(content: string, secondLine?: string)
	{
		super.setContent(content);

		if (secondLine)
			this._SecondLine = secondLine;

		let res = '';

		if (this._SecondLine)
		{
			let images = this._SecondLineImages ? this._SecondLineImages.filter(item => !!item).map(item => `<span class="app-list-item__secondary-text__image ${item}"></span>`).join('') : '';
			res = `<span class="app-list-item__text">` +
				 `<span class="app-list-item__primary-text" ${this._AddToolTips ? `title="${content}"` : ''}>${content}</span>` +
				 `<span class="app-list-item__secondary-text" ${this._AddToolTips ? `title="${this._SecondLine.trim()}"` : ''}>${images}${this._SecondLine}</span>` +
				 `</span>`;

			this.removeClass('no-second-line');
		}
		else
		{
			res = `<span class="app-list-item__text" ${this._AddToolTips ? `title="${content}"` : ''}>${content}</span>`;
			this.addClass('no-second-line');
		}

		if (this._FontImage)
			this._root.innerHTML = `<span class="app-list-item__graphic ${this._FontImage}"></span>${res}`;
		else if (this._Image)
			this._root.innerHTML = `<span class="app-list-item__graphic">${this._Image}</span>${res}`;
		else
			this._root.innerHTML = res;

		if (this._ShowDeleteButton)
			this.setShowDeleteButton(true);
	}

	getShowDeleteButton()
	{
		return this._ShowDeleteButton;
	}

	setShowDeleteButton(value: boolean)
	{
		if (this._IsSeparator)
			return;
		this._ShowDeleteButton = value;
		if (value)
		{
			if (this._delButton)
				this._delButton.show();
			else
			{

				let settings = {
					ParentNode: this._root,
					FontImage: NP.FontImages.close,
					Parent: this,
					Class: '',
					EvMouseOut: () => this.removeClass('app-list-item--no-hover'),
					EvMouseOver: () => this.addClass('app-list-item--no-hover'),
					...this._DelBtnSettings
				};

				if (!settings.Class)
					settings.Class = "";

				settings.Class += ' app-list-item__meta app-list-item__delete';

				this._delButton = new IconToggleButton(settings);
				this._delButton.EvClick.add(this._onDeleteClick, this);
			}
		}
		else if (this._delButton)
			this._delButton.hide();
	}

	_onDeleteClick()
	{
		this._deletedClick = true;
		this.EvDeletedClick.fire(this);
	}

	_onClicked(sender: Control, args: EventArgs)
	{
		if (this._deletedClick)
			this._deletedClick = false;
		else if (!this._IsSeparator)
			super._onClicked(sender, args);
	}

	setFontImage(value: string)
	{
		let node = this._root.querySelector('.app-list-item__graphic');
		NP.removeCssClass(node, this._FontImage);
		NP.addCssClass(node, value);
		this._FontImage = value;
	}

	getFontImage()
	{
		return this._FontImage;
	}

	getIsChecked()
	{
		return this._FontImage == NP.FontImages.check;
	}

	setIsChecked(value: boolean)
	{
		this.setFontImage(value ? NP.FontImages.check : ' ');
	}

}